<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden mt-3">
      <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Velkomoravská říše</h2>
      <div>
        <h3 class="text-blue-600 text-lg font-bold">Počátky Velkomoravské říše</h3>
        <p class="pb-2">
          Během 9. století přejala na našem území vůdčí úlohu Morava. V průběhu 9. století n. l. se na Moravě a na jihozápadním Slovensku rozkládal
          <strong>první státní útvar - Velkomoravská říše</strong>.Prvním historicky známým vládcem této říše byl <strong>kníže Mojmír</strong>. Ten porazil slovenského knížete
          <strong>Pribinu</strong>, a upevnil tak svoji vládu. Za Mojmírova nástupce <strong>Rastislava</strong> už byla Velká Morava mocným evropským státem. V této době bylo dosavadní pohanské
          (mnohobožství) náboženství vytlačováno novým náboženstvím - <strong>křesťanstvím</strong>. Pohanství znamenalo víru v mnoho bohů a bůžků. Křesťanství oproti tomu hlásá víru v
          <strong>jednoho Boha</strong>. Vyzývá k lásce a pomoci. Odmítá lež, násilí a nenávist. Křesťané se na znamení víry dávají <strong>pokřtít</strong>. Už od 8. století přicházeli na Moravu
          kněží z Franské říše (dnešního Německa a Francie) <strong>šířit křesťanství</strong>. Protože mluvili německy nebo latinsky, lidé jim nerozuměli. Kníže Rastislav proto hledal kněze, kteří by
          u nás <strong>šířili křesťanství lidu srozumitelným jazykem.</strong> O pomoc požádal <strong>císaře byzantské říše</strong>.
          <span class="block italic text-sm text-gray-700 bg-yellow-200 p-1 rounded my-1">
            <strong>Byzantská říše</strong> - velká říše, která byl v této době vyspělejší než státy západní Evropy. Rozkládala se v jižní Evropě, částečně i v Asii a v Africe, např. na území dnešního
            Turecka, Řecka a Egypta. Přibližně před 550 lety zanikla.
          </span>
        </p>
        <div class="lg:flex  pb-2">
          <div class="w-full lg:w-4/6 bg-yellow-100">
            <h3 class="text-blue-600 text-lg font-bold">Působení Konstantina a Metoděje</h3>
            <p class=" leading-relaxed">
              <strong>Roku 863</strong> poslal byzantský císař <strong>do Velkomoravské říše</strong> dva vzdělané bratry, kněze <strong>Konstantina</strong> a <strong>Metoděje</strong>. Ti pocházeli
              ze Soluně (území dnešního Řecka), kde tehdy žilo mnoho Slovanů. Oba bratři proto ovládali <strong>slovanský jazyk</strong> a začali ho na Moravě používat při bohoslužbách. Do té doby se
              totiž v kostelích kázalo pouze latinsky. Kostantin sestavil <strong>první slovanské písmo</strong> nazvané <strong>hlaholice</strong>. Do slovanského jazyka také přeložil hlavní části
              <strong>Písma Svatého (Bible)</strong>. Dílo bratrů bylo úspěšné a za podpory Rastislava <strong>získali pro křesťanskou víru většinu národa</strong>. Franští kněží si však stěžovali u
              papeže, že se na Moravě neužívá při bohoslužbách latina. Konstantin s Metodějem proto museli jít k papeži do Říma obhajovat svoje učení. To se jim podařili. Konstantin v Římě onemocněl,
              vstoupil do kláštera, kde přijal jméno <strong>Cyril</strong>, a brzy poté zemřel. Metoděj se vrátil zpět na Moravu.
            </p>
            <h3 class="text-blue-600 text-lg font-bold">Konec slovanské bohoslužby</h3>
            <p>
              Na Moravě se zatím stal knížetem <strong>Svatopluk</strong>. Za jeho vlády Metoděj ještě několik let pokračoval ve svém díle. Po Metodějově smrti byli však jeho žáci vyhnáni ze země a
              bohoslužby se začaly opět konat <strong>latinsky</strong>. Proto se nakonec na našem území ustálilo latinské písmo - <strong>latinka</strong>. Bratři Konstantin a Metoděj byli pro svoje
              zásluhy o šíření křesťanství prohlášeni církví za svaté. <strong>5. červenec</strong> byl u nás na jejich počest vyhlášen <strong>státním svátkem.</strong>
            </p>
            <p>
              Přečtěte si pověst o
              <a class="font-bold underline text-orange-600 hover:text-orange-700 " href="http://pohadky-online.eu/ceske-povesti-pro-male-deti/synove-svatoplukovi/" target="_blank">Svatoplukovi</a>.
            </p>
          </div>
          <img class="w-full lg:w-1/6 rounded " src="https://upload.wikimedia.org/wikipedia/commons/8/8f/Jano_K%C3%B6hler_-_Cyril_a_Metod%C4%9Bj.jpg" alt="" />
          <img class="w-full lg:w-1/6 rounded " src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/ZographensisColour.jpg/377px-ZographensisColour.jpg" alt="" />
        </div>
        <div class="lg:flex py-4 ">
          <div class="w-full lg:w-3/4  pr-2">
            <h3 class="text-blue-600 text-lg font-bold">Rozvoj řemesel</h3>
            <p class="pb-2">
              Konstantin a Metoděj si přivedli na Velkou Moravu pomocníky, kteří předávali obyvatelům této země své znalosti i dovednosti. S jejich pomocí se rozvíjela
              <strong>samostatná řemesla</strong>. Velké mistrovství dosahovalo <strong>šperkařství</strong>. Specializované dílny vyráběly <strong>sklo</strong> nebo se věnovaly
              <strong>řezbářství</strong>. <strong>Kováři</strong> vyráběli zemědělské nářadí a zbraně. <strong>Hrnčíři</strong> vytvářeli nádoby i dlaždice. V jiných dílnách vznikaly
              <strong>tkaniny, oděvy </strong> a <strong>obuv</strong>. Velký význam začal mít <strong>obchod</strong>.
              <span class="block italic text-sm text-gray-700 bg-yellow-200 p-1 rounded my-1">
                V hrobech z té doby byly objeveny šperky, spony, hřebeny a knoflíky ze zlata a stříbra zvané <strong>gombíky</strong>. Cenné nálezy pocházejí zejména z <strong>Mikulčic</strong> (jižní
                Morava) a z okolí <strong>Uherského Hradiště</strong>
                (východní Morava).
              </span>
            </p>
            <h3 class="text-blue-600 text-lg font-bold">Zánik Velkomoravské říše</h3>
            <p>
              Po Svatoplukově smrti Velkomoravská říše neodolala <strong> nájezdům kočovných Maďarů</strong> a na <strong>počátku 10. století n. l. </strong> (kolem roku 906)
              <strong> se rozpadla</strong>. <strong>Čechy</strong> a <strong>Morava se od té doby začaly vyvíjet samostatně</strong>.
            </p>
            <p>Chceš se dozvědět více? Čti <a class="underline font-bold" target="_blank" href="http://pohadky-online.eu/ceske-povesti-pro-male-deti">tady</a></p>
          </div>
          <div class="w-full lg:w-1/4">
            <iframe
              class="w-full h-64 lg:h-full"
              src="https://www.youtube.com/embed/JBRT57xwMe4"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Morava"
};
</script>

<style lang="scss" scoped></style>
